import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Preview.module.css';
import moment from 'moment';
import { Link, useParams } from 'react-router-dom';
import { usePreview } from '../hooks/use-issue';
import imgLogo from '../components/navbar/logo.png';
import { LoginModal } from './LoginModal';
import { AppContext } from '../services/AppContext';
const PreviewCtx = createContext({
	issue: null,
});
export default function Preview() {
	const { id } = useParams();
	const { isUserLoggedIn } = useContext(AppContext);
	const [isLoginOpen, setIsLoginOpen] = useState(false);
	const { isLoading, issue } = usePreview(id);
	useEffect(() => {
		if (!isUserLoggedIn()) {
			window.location.href = '/';
			return;
		}
	}, []);
	if (isLoading) {
		return null;
	}
	return (
		<PreviewCtx.Provider
			value={{
				issue,
			}}
		>
			<LoginModal
				isOpen={isLoginOpen}
				onClose={() => {
					setIsLoginOpen(false);
				}}
			/>
			<div className={styles['container']}>
				<Navbar setIsLoginOpen={setIsLoginOpen} />
				<main>
					<Summary />
					<Actions />
					<Details />
				</main>
			</div>
		</PreviewCtx.Provider>
	);
}

function Navbar({ setIsLoginOpen }) {
	return (
		<nav>
			<div>
				<Link to={'/'}>
					<img src={imgLogo} />
				</Link>
			</div>
			<div>
				<button
					onClick={() => {
						setIsLoginOpen(true);
					}}
				>
					Login
				</button>
			</div>
		</nav>
	);
}

Navbar.propTypes = {
	setIsLoginOpen: PropTypes.func,
};

function Summary() {
	const { issue } = useContext(PreviewCtx);

	if (!issue) {
		return null;
	}

	const { slug, id, description, name, cover } = issue;
	console.log(`Issue`, issue);
	return (
		<div className={styles['summary']}>
			<div className={styles['cover']}>
				<Link to={`/issues/${slug ? slug : id}`}>
					<img alt="Consent" src={cover} />
				</Link>
			</div>

			<div>
				{moment(issue.updated).format('MMM Do YYYY')}. <br /> {name}
				{description ? <p>{description}</p> : null}
			</div>
		</div>
	);
}

function Actions() {
	const { issue } = useContext(PreviewCtx);
	if (!issue) {
		return null;
	}
	return (
		<div className={styles['actions']}>
			<Link to={`/issues/${issue.slug ? issue.slug : issue.id}`}>
				View
			</Link>
			<Link to={`/issues/${issue.slug ? issue.slug : issue.id}`}>
				Download
			</Link>
		</div>
	);
}

function Details() {
	const { issue } = useContext(PreviewCtx);
	if (!issue) {
		return null;
	}
	return (
		<div className={styles['details']}>
			<p>{issue.description}</p>
		</div>
	);
}
